import * as React from "react"

import { cn } from "@/lib/utils"
import { formatNumber } from "@/lib/format"

/*
  SidebarCount — the count badge at the end of a sidebar link (02 #8): "Projects 45", and the lime
  "alert" badge for counts that need the viewer ("Tasks 7" overdue / assigned to me).

    <Link className="ui-nav-item" …><Icon /><span>Tasks</span>
      <SidebarCount count={7} tone="alert" label="7 tasks need you" /></Link>
    // collapsed sidebar (icons only): a dot on the icon corner, the number for screen readers
    <SidebarCount count={7} tone="alert" collapsed label="7 tasks need you" />

  Hidden when the count is empty or 0 (unless showZero). Big numbers read "99+" (max).
  Props: count, tone ('default' | 'alert'), label (screen-reader text, default the number),
  max (99), showZero, collapsed, className. Styles: `.ui-sb-count`, `.ui-sb-dot` (index.css);
  the group heading style is `.ui-sb-section`.
*/
function SidebarCount({ count, tone = "default", label, max = 99, showZero = false, collapsed = false, className }) {
  const number = Number(count)
  if (count === null || count === undefined || count === "" || !Number.isFinite(number)) return null
  if (number <= 0 && !showZero) return null
  const text = number > max ? `${formatNumber(max, { maxDecimals: 0 })}+` : formatNumber(number, { maxDecimals: 0 })
  const spoken = label || text
  if (collapsed) {
    return (
      <span className={cn("ui-sb-dot", className)} data-tone={tone} data-testid="sidebar-count">
        <span className="sr-only">{spoken}</span>
      </span>
    )
  }
  return (
    <span className={cn("ui-sb-count", className)} data-tone={tone} data-testid="sidebar-count">
      <span aria-hidden={label ? "true" : undefined}>{text}</span>
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  )
}

export { SidebarCount }
